module.exports = __webpack_public_path__ + "img/basic-package.64afd6f4.svg";